export enum EnumComposerMenu {
  ROOT = 'root',
  ANEXAR = 'anexar',
  ACOES = 'acoes'
}
